import { Component } from "@angular/core";
import { Lessee, LesseeProviders } from '../../../../../_models';

@Component({
    selector: 'app-lessees-list',
    templateUrl: './lessees-list.component.html',
    styleUrls: ['./lessees-list.component.scss'],
    providers: [LesseeProviders]
})

export class LesseesListComponent {
    header = {
        icon: 'fa fa-user',
        text: 'Arrendatarios'
    };
    newEntry = {
        link: '/lessees/new',
        text: 'Agregar'
    };
    selectedLessee: number;
    constructor(private lesseeData: Lessee, ) {
        lesseeData.getAll().subscribe(lessees => { });
    }

    deleteEl(element) {
        this.lesseeData.delete(element).subscribe(response => {
            this.lesseeData.getAll().subscribe(lessees => { });
        })
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/lessees/lessees-list/lessees-list.component.ts